import React, { useEffect, useState, useRef } from "react";
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  InputLabel,
  FormControl,
  MenuItem,
  Select,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Pagination,
  PaginationItem,
  Grid
} from "@mui/material";
import { Add, Delete, Download, FilterList, MoreVert, Search, FirstPage, LastPage, Close, PhotoCamera, Remove } from "@mui/icons-material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import { TrashOutline } from "react-ionicons";
import "../../../shared/components/Item.css";
import { useNavigate } from "react-router-dom";

import { ItemSearchParams, getItems, createItemCategory, uploadItemPhoto, editItemCategory, fetchItemPhotoBlob, deleteItem } from "../services/itemService.tsx";
import Swal from "sweetalert2";
import * as XLSX from 'xlsx';

// Set z-index global
Swal.mixin({
  customClass: {
    popup: 'swal-z-index'
  },
  backdrop: `rgba(0,0,0,0.4)`
});


const Item: React.FC = () => {
  const [selectedRows, setSelectedRows] = useState<number[]>([]);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
  const [rows, setRows] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total semua data
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [openAddCategoryDialog, setOpenAddCategoryDialog] = useState(false);
  const [openAddItemDetailsDialog, setOpenAddItemDetailsDialog] = useState(false);

  const [error, setError] = useState("");
  const [openFilterDialog, setOpenFilterDialog] = useState(false);
  const [filters, setFilters] = useState([{ field: "name", value: "" }]);

  const [isLoading, setIsLoading] = useState(true);
  const navigate = useNavigate();

  const [itemsToDelete, setItemsToDelete] = useState<any[]>([]);


  const offset = (currentPage - 1) * rowsPerPage;

  const [sortConfig, setSortConfig] = useState<{ orderBy: string; order: "asc" | "desc" }>({
    orderBy: "createdAt",
    order: "desc",
  });

  const handleSort = (column: string) => {
    setSortConfig((prev) => {
      if (prev.orderBy === column) {
        return {
          orderBy: column,
          order: prev.order === "asc" ? "desc" : "asc",
        };
      } else {
        return {
          orderBy: column,
          order: "asc",
        };
      }
    });
    setCurrentPage(1); // reset ke halaman 1 saat sort berubah
  };


  // Daftar pilihan filter yang tersedia
  const availableFilters = [
    { value: "code", label: "Item Code" },
    { value: "name", label: "Item Name" },
    { value: "description", label: "Description" },
    { value: "category", label: "Category" },
  ];

  // Daftar pilihan filter yang tersedia
  const availableFiltersInit = [
    { value: "code", label: "Item Code" },
    { value: "name", label: "Item Name" },
    { value: "description", label: "Description" },
    { value: "category", label: "Category" },
  ];


  const [filterParams, setFilterParams] = useState<{
    keyword?: string;
    code?: string;
    name?: string;
    description?: string;
    category?: string;
  }>({});



  const fetchItems = async () => {
    setIsLoading(true);
    try {


      const result = await getItems({
        ...filterParams,
        limit: rowsPerPage,
        offset,
        orderBy: sortConfig.orderBy,
        order: sortConfig.order,
      });


      setRows(result.data);
      setTotalPages(result.pagination.totalPages);
      setTotalItems(result.total);
    } catch (err) {
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  // Fetch data on mount
  useEffect(() => {

    fetchItems();
  }, [currentPage, rowsPerPage, filterParams, sortConfig]);




  const handleSelectRow = (id: number) => {
    setSelectedRows((prev) =>
      prev.includes(id) ? prev.filter((rowId) => rowId !== id) : [...prev, id]
    );
  };

  // const handleDeleteRows = () => {
  //   setRows(rows.filter((row) => !selectedRows.includes(row.id)));
  //   setSelectedRows([]); // Reset pilihan setelah dihapus
  //   setOpenDeleteDialog(false);
  // };
  const handleDeleteRows = async () => {
    try {
      await Promise.all(selectedRows.map(async (id) => await deleteItem(id)));

      Swal.fire({
        icon: "success",
        title: "Item berhasil dihapus",
        confirmButtonColor: "#0F62FE",
      });

      setSelectedRows([]);
      fetchItems(); // refresh data
      setOpenDeleteDialog(false);
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menghapus item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };


  // const totalPages = Math.ceil(rows.length / rowsPerPage);
  const displayedRows = rows.slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage);

  //details form
  const [formData, setFormData] = useState({
    itemGroup: "",
    materialGrade: "",
    complianceStandard: "",
    areaOfBuy: "",
    unitPrice: "",
    supplierVendor: "",
    measurementUnits: [{ length: "", size: "" }],
    remarks: "",
  });

  const [categoryData, setCategoryData] = useState<{
    itemGroupName: string;
    itemDescription: string;
    selectedItem: string;
    file: File | null;
  }>({
    itemGroupName: "",
    itemDescription: "",
    selectedItem: "",
    file: null,
  });


  const fileInputRef = useRef<HTMLInputElement>(null);
  const editFileInputRef = useRef<HTMLInputElement>(null);

  const handleFileUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setCategoryData({ ...categoryData, file });
  };

  const [itemDetailsData, setItemDetailsData] = useState<{
    itemGroup: string,
    materialGrade: string,
    complianceStandard: string,
    areaOfBuy: string,
    unitPrice: string,
    supplierVendor: string,
    remarks: string,
    file: File | null;
  }>({
    itemGroup: "",
    materialGrade: "",
    complianceStandard: "",
    areaOfBuy: "",
    unitPrice: "",
    supplierVendor: "",
    remarks: "",
    file: null,
  });


  const handleFileDetailUpload = (file: File) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setItemDetailsData({ ...itemDetailsData, file });
  };


  const [openEditCategoryDialog, setOpenEditCategoryDialog] = useState(false);
  const [isEditingCategory, setIsEditingCategory] = useState(false); // Mengontrol mode edit

  const [editCategoryData, setEditCategoryData] = useState<{
    id: string,
    itemGroupName: string,
    itemDescription: string,
    selectedItem: string,
    file: File | null,
    photoItem: string,
    previewUrl: string,
  }>({
    id: "",
    itemGroupName: "",
    itemDescription: "",
    selectedItem: "",
    file: null,
    photoItem: "",
    previewUrl: "",
  });

  const [originalCategoryData, setOriginalCategoryData] = useState<{
    id: string,
    itemGroupName: string,
    itemDescription: string,
    selectedItem: string,
    file: File | null,
    photoItem: string,
    previewUrl: string,
  }>({
    id: "",
    itemGroupName: "",
    itemDescription: "",
    selectedItem: "",
    file: null,
    photoItem: "",
    previewUrl: "",
  });

  const [addCategoryErrors, setAddCategoryErrors] = useState({
    itemGroupName: false,
    itemDescription: false,
    selectedItem: false,
  });

  const [editCategoryErrors, setEditCategoryErrors] = useState({
    itemGroupName: false,
    itemDescription: false,
    selectedItem: false,
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleEditCategoryInputChange = (e) => {
    if (!isEditingCategory) return; // Hanya bisa diedit saat mode edit aktif
    const { name, value } = e.target;
    setEditCategoryData({ ...editCategoryData, [name]: value });
  };

  const handleEditCategoryFileUpload = (file) => {
    const validTypes = ["image/png", "image/jpeg", "image/jpg"];
    const maxSize = 5 * 1024 * 1024; // 5MB

    if (!validTypes.includes(file.type)) {
      Swal.fire({
        icon: "warning",
        title: "Format tidak didukung",
        text: "Hanya file .png, .jpg, dan .jpeg yang diperbolehkan",
      });
      return;
    }

    if (file.size > maxSize) {
      Swal.fire({
        icon: "warning",
        title: "Ukuran file terlalu besar",
        text: "Ukuran maksimum adalah 5MB",
      });
      return;
    }

    setEditCategoryData({ ...editCategoryData, file });
  };

  const validateEditCategoryForm = () => {
    let newErrors = {
      itemGroupName: !editCategoryData.itemGroupName,
      itemDescription: !editCategoryData.itemDescription,
      selectedItem: !editCategoryData.selectedItem,
    };

    setEditCategoryErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const validateAddCategoryForm = () => {
    let newErrors = {
      itemGroupName: !categoryData.itemGroupName,
      itemDescription: !categoryData.itemDescription,
      selectedItem: !categoryData.selectedItem,
    };

    setAddCategoryErrors(newErrors);
    return !Object.values(newErrors).includes(true);
  };

  const handleSubmitAddCategory = async () => {
    if (!validateAddCategoryForm()) return;
    try {
      // Step 1: Create item category
      const newItem = await createItemCategory(categoryData); // get response with `id` or `code`

      // Step 2: Upload photo if available
      if (categoryData.file) {
        await uploadItemPhoto(newItem.id, categoryData.file);
      }

      Swal.fire({
        icon: "success",
        title: "Item berhasil ditambahkan",
        confirmButtonColor: "#0F62FE",
      });
      setOpenAddCategoryDialog(false);
      fetchItems();

    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal menambahkan item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleSubmitEditCategory = async () => {
    if (validateEditCategoryForm()) {
      console.log("Updated Category Data:", editCategoryData);
      setIsEditingCategory(false);
      setOpenEditCategoryDialog(false);
    }
    if (!validateEditCategoryForm()) return;

    try {
      const updatedItem = await editItemCategory(editCategoryData);
      if (editCategoryData.file && editCategoryData.file.name !== originalCategoryData.photoItem) {
        await uploadItemPhoto(editCategoryData.id, editCategoryData.file);
      }

      Swal.fire({
        icon: "success",
        title: "Item berhasil diperbarui",
        confirmButtonColor: "#0F62FE",
      });

      setOpenEditCategoryDialog(false);
      setIsEditingCategory(false);

      // Optional: refresh item list
      fetchItems();
      setCurrentPage(1); // agar fetch ulang
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Gagal memperbarui item",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
    }
  };

  const handleOpenEditCategory = async (category) => {
    const photoItem = category.photoItem;

    let previewUrl;
    if (photoItem && typeof photoItem === "string") {
      previewUrl = await fetchItemPhotoBlob(photoItem);
    }


    setEditCategoryData({
      id: category.id, // ← tambahkan id
      itemGroupName: category.name,
      itemDescription: category.description,
      selectedItem: category.category,
      file: null,
      photoItem: category.photoItem,
      previewUrl, // ← simpan di state
    });
    setOriginalCategoryData(category); // Simpan nilai asli untuk tombol cancel
    setIsEditingCategory(false); // Kunci form sampai tombol edit diklik
    setOpenEditCategoryDialog(true);
  };

  const handleCancelEditCategory = () => {
    setEditCategoryData(originalCategoryData); // Kembalikan nilai asli
    setIsEditingCategory(false); // Kunci kembali form
    setOpenEditCategoryDialog(false);
  };

  // FILTER

  const handleFilterChange = (index: number, key: string, value: string) => {
    const newFilters = [...filters];
    newFilters[index][key] = value;
    setFilters(newFilters);
  };

  const handleAddFilter = () => {
    setFilters([...filters, { field: "nik", value: "" }]);
  };

  const handleRemoveFilter = (index: number) => {
    setFilters(filters.filter((_, i) => i !== index));
  };

  const handleApplyFilters = async () => {
    setIsLoading(true);
    try {
      // Buat object parameter pencarian sesuai `ItemSearchParams`
      const searchParams: ItemSearchParams = {};

      filters.forEach((filter) => {
        if (filter.value.trim() !== "") {
          searchParams[filter.field] = filter.value;
        }
      });

      // // Panggil fungsi pencarian dari itemServices.tsx
      // const response = await getItems(searchParams);
      // console.log(response);
      // // Format hasil pencarian sebelum ditampilkan di tabel
      // handleSearchResults(response.data);

      setFilterParams(searchParams);
      setOpenFilterDialog(false);
    } catch (error) {
      console.error("Error fetching data:", error);
      Swal.fire({
        icon: "error",
        title: "Gagal mengambil data",
        text: error.response?.data?.message || "Terjadi kesalahan",
      });
      handleCloseFilter();
    } finally {
      setIsLoading(false);
    }
  };

  // ✅ Tambahkan fungsi ini
  const handleSearchResults = (results) => {
    setRows(results); // Update rows agar sesuai dengan format tabel
    setOpenFilterDialog(false); // Tutup dialog setelah apply filter
  };

  const handleCloseFilter = () => {
    setOpenFilterDialog(false);
  };

  const handleResetFilters = () => {
    setFilters([{ field: "", value: "" }]); // Reset ke kondisi awal dengan satu filter kosong
  };

  //======================= Search ===================================
  const handleSearch = async () => {
    // if (searchQuery.trim() === "") return; // Hindari pencarian kosong
    setIsLoading(true);
    setError("");

    try {
      // const results = await getItems({
      //   keyword: searchQuery,
      //   limit: rowsPerPage,
      //   offset,
      // });
      setFilterParams(
        {
          keyword: searchQuery
        }
      );
    } catch (err) {
      setError(err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleExport = async () => {
    try {
      // Tampilkan loading
      Swal.fire({
        title: 'Preparing Export...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        }
      });

      // Opsi 1: Export semua data (dengan filter yang sama seperti tabel)
      const exportData = await getExportData();

      // Opsi 2: Export hanya data yang terlihat di tabel saat ini
      // const exportData = rows.map(formatEmployeeForExport);

      // Opsi 3: Export hanya data yang dipilih
      // if (selectedRows.length === 0) {
      //   Swal.fire({
      //     icon: 'warning',
      //     title: 'No Selection',
      //     text: 'Please select at least one employee to export',
      //   });
      //   return;
      // }
      // const exportData = rows
      //   .filter(row => selectedRows.includes(row.id))
      //   .map(formatEmployeeForExport);

      // Buat worksheet
      const ws = XLSX.utils.json_to_sheet(exportData);

      // Buat workbook
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Items");

      // Generate file Excel
      const date = new Date().toISOString().slice(0, 10);
      XLSX.writeFile(wb, `Items_${date}.xlsx`);

      // Tutup loading
      Swal.close();

    } catch (error) {
      console.error('Export failed:', error);
      Swal.fire({
        icon: 'error',
        title: 'Export Failed',
        text: error.message || 'Failed to export employee data',
      });
    }
  };

  // Fungsi untuk mengambil data yang akan diexport
  const getExportData = async () => {
    const allItems = await getItems({
      ...filterParams,
      limit: 10000, // Ambil semua data
      offset: 0,
      orderBy: sortConfig.orderBy,
      order: sortConfig.order,
    });

    return allItems.data.map(item => ({
      'Item Code': item.code,
      'Item Name': item.name,
      'Description': item.description,
      'Category': item.category,
      'Created At': item.createdAt,
    }));
  };


  return (
    <Box sx={{ padding: 3 }}>
      {/* Header & Tabs */}
      <Box sx={{ display: "flex", alignItems: "center", gap: 2, marginBottom: 2 }}>
        <Typography variant="h6" fontWeight="bold">
          Item List
        </Typography>
        <Box sx={{ display: "flex", gap: 1 }}>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#F0F3FA", color: "#000", textTransform: "none" }}
            onClick={() => navigate("/data-management/item")}
          >
            Item
          </Button>
          <Button
            variant="contained"
            sx={{ backgroundColor: "#D1F7D1", color: "#000", textTransform: "none" }}
            onClick={() => navigate("/data-management/item-detail")}
          >
            Item Details
          </Button>
        </Box>

      </Box>

      {/* Toolbar */}
      <Box className="toolbar">
        {/* Left Controls */}
        <Box className="leftControls">
          <Typography>Show</Typography>
          <Select value={rowsPerPage} onChange={(e) => {
            setRowsPerPage(Number(e.target.value));
            setCurrentPage(1); // reset ke halaman 1 saat ganti limit
          }} size="small">
            <MenuItem value={5}>5</MenuItem>
            <MenuItem value={10}>10</MenuItem>
            <MenuItem value={25}>25</MenuItem>
          </Select>


          {/* Search Button & Input */}
          <Button
            variant="contained"
            startIcon={<Search />}
            onClick={() => setShowSearch((prev) => !prev)}
            className="searchButton"
          >
            Search
          </Button>
          {showSearch && (
            <TextField
              variant="outlined"
              size="small"
              placeholder="Search"
              value={searchQuery}
              onChange={async (e) => {
                await setSearchQuery(e.target.value);
              }}
              onKeyPress={(e) => e.key === "Enter" && handleSearch()} // Pencarian dengan Enter
              autoFocus
              className="searchInput"
            />
          )}

          {/* Menampilkan Error */}
          {error && <p style={{ color: "red" }}>{error}</p>}
        </Box>

        {/* Right Controls */}
        <Box className="rightControls">
          <Button
            startIcon={<Delete />}
            variant="text"
            onClick={() => {
              const selectedData = rows.filter((row) => selectedRows.includes(row.id));
              setItemsToDelete(selectedData);
              setOpenDeleteDialog(true);
            }}
            disabled={selectedRows.length === 0}
          >
            Delete
          </Button>
          {/* Filter Button */}
          <Button
            startIcon={<FilterList />}
            variant="text"
            onClick={() => setOpenFilterDialog(true)}
          >
            Filters
          </Button>
          <Button startIcon={<Download />} variant="contained" className="exportButton" onClick={() => handleExport()}>
            Export
          </Button>
          <Button startIcon={<Add />} variant="contained" className="addCategoryButton" onClick={() => setOpenAddCategoryDialog(true)}>
            Add New Item Category
          </Button>
        </Box>
      </Box>


      {/* Delete Button & Subtitle */}
      {/* <Box className="deleteContainer">
        <IconButton
          onClick={() => setOpenDeleteDialog(true)}
          disabled={selectedRows.length === 0} // Disable jika tidak ada baris yang dipilih
          className="deleteButton"
        >
          <TrashOutline color={"#333"} height="20px" width="20px" />
        </IconButton>
      </Box> */}

      <Box className="deleteContainer">
        <Typography variant="body2" className="detailsSubtitle">
          Details List Of All Items
        </Typography>
      </Box>


      {/* Table */}
      <TableContainer component={Paper} className="tableContainer">
        <Table className="table">
          <TableHead className="tableHead">
            <TableRow>
              <TableCell padding="checkbox" className="tableCell">
                <Checkbox
                  indeterminate={selectedRows.length > 0 && selectedRows.length < rows.length}
                  checked={selectedRows.length === rows.length}
                  onChange={() =>
                    setSelectedRows(selectedRows.length === rows.length ? [] : rows.map((row) => row.id))
                  }
                />
              </TableCell>
              <TableCell>No</TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("name")} style={{ cursor: "pointer" }}>
                <strong>Item Name</strong>
                {sortConfig.orderBy === "name" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("description")} style={{ cursor: "pointer" }}>
                <strong>Description</strong>
                {sortConfig.orderBy === "description" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("category")} style={{ cursor: "pointer" }}>
                <strong>Category</strong>
                {sortConfig.orderBy === "category" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell" onClick={() => handleSort("createdAt")} style={{ cursor: "pointer" }}>
                <strong>Created At</strong>
                {sortConfig.orderBy === "createdAt" && (sortConfig.order === "asc" ? " ▲" : " ▼")}
              </TableCell>
              <TableCell className="tableCell"></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, index) => (
              <TableRow key={row.id} selected={selectedRows.includes(row.id)}>
                <TableCell padding="checkbox" className="tableCell">
                  <Checkbox
                    checked={selectedRows.includes(row.id)}
                    onChange={() => handleSelectRow(row.id)}
                  />
                </TableCell>
                <TableCell>
                  {/* Nomor urut disesuaikan dengan pagination */}
                  {offset + index + 1}
                </TableCell>
                <TableCell className="tableCell">{row.name}</TableCell>
                <TableCell className="tableCell">{row.description}</TableCell>
                <TableCell className="tableCell">{row.category}</TableCell>
                <TableCell className="tableCell">{new Date(row.createdAt).toLocaleDateString()}</TableCell>
                <TableCell className="tableCell">
                  <IconButton onClick={() => handleOpenEditCategory(row)}>
                    <MoreVert />
                  </IconButton>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>

      {/* Pagination */}
      <Box
        className="paginationContainer"
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
          padding: "16px 0",
        }}
      >
        {/* Info jumlah data */}
        <Typography variant="body2" sx={{ color: "text.secondary" }}>
          {`Showing ${offset + 1} to ${Math.min(
            offset + rowsPerPage,
            totalItems
          )} of ${totalItems} entries`}
        </Typography>

        {/* Komponen Pagination */}
        <Pagination
          count={totalPages}
          page={currentPage}
          onChange={(e, page) => setCurrentPage(page)}
          className="pagination"
          showFirstButton
          showLastButton
          renderItem={(item) => (
            <PaginationItem
              {...item}
              components={{ first: FirstPage, last: LastPage }}
            />
          )}
        />
      </Box>

      {/* Delete Confirmation Dialog */}
      <Dialog open={openDeleteDialog} onClose={() => setOpenDeleteDialog(false)}>
        <DialogTitle>Delete Rows?</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Are you sure you want to delete the selected item(s)?
          </DialogContentText>
          {/* <ul style={{ paddingLeft: "1.5rem", marginTop: "0.5rem" }}>
            {itemsToDelete.map((item) => (
              <li key={item.id}>
                <strong>{item.name}</strong> (Code: {item.code})
              </li>
            ))}
          </ul> */}
        </DialogContent>

        <DialogActions>
          <Button onClick={() => setOpenDeleteDialog(false)}>Cancel</Button>
          <Button onClick={handleDeleteRows} color="error">Delete</Button>
        </DialogActions>
      </Dialog>

      {/* POPUP Add New Item Category */}
      <Dialog open={openAddCategoryDialog} onClose={() => setOpenAddCategoryDialog(false)} fullWidth maxWidth="md"
        sx={{ backdropFilter: "blur(5px)" }}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight="bold">Add New Item Category</Typography>
            <IconButton onClick={() => setOpenAddCategoryDialog(false)} color="error"><Close /></IconButton>
          </Box>
        </DialogTitle>
        <DialogContent>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* File Upload Section */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #aaa",
                padding: 4,
                borderRadius: "12px",
                backgroundColor: "#fafafa",
                textAlign: "center",
                cursor: "pointer",
                position: "relative"
              }}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                e.preventDefault();
                const file = e.dataTransfer.files[0];
                handleFileUpload(file);
              }}
              onClick={() => fileInputRef.current?.click()}
            >
              {categoryData.file ? (
                <img
                  src={URL.createObjectURL(categoryData.file)}
                  alt="Preview"
                  style={{ width: "100%", height: "auto", borderRadius: "8px", objectFit: "contain", maxHeight: 180 }}
                />
              ) : (
                <>
                  <PhotoCamera fontSize="large" />
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    Drag & drop or click to upload image
                  </Typography>
                </>
              )}
              <input
                hidden
                accept="image/png, image/jpeg, image/jpg"
                type="file"
                ref={fileInputRef}
                onChange={(e) => handleFileUpload(e.target.files[0])}
              />
              <Typography variant="caption" mt={1}>
                Max size: 5MB (.png, .jpg, .jpeg)
              </Typography>
            </Box>

            {/* Form Section */}
            <Box sx={{ flex: 2 }}>
              <TextField
                fullWidth
                label="Item Group Name"
                name="itemGroupName"
                value={categoryData.itemGroupName}
                onChange={(e) => setCategoryData({ ...categoryData, itemGroupName: e.target.value })}
                error={addCategoryErrors.itemGroupName}
                helperText={addCategoryErrors.itemGroupName ? "Mandatory Field" : ""}
                margin="normal"
              />
              <TextField
                fullWidth
                label="Item Description"
                multiline
                rows={4}
                name="itemDescription"
                value={categoryData.itemDescription}
                onChange={(e) => setCategoryData({ ...categoryData, itemDescription: e.target.value })}
                error={addCategoryErrors.itemDescription}
                helperText={addCategoryErrors.itemDescription ? "Mandatory Field" : ""}
                margin="normal"
              />
              <TextField
                select
                fullWidth
                label="Category"
                placeholder="Category"
                value={categoryData.selectedItem}
                onChange={(e) => setCategoryData({ ...categoryData, selectedItem: e.target.value })}
                error={addCategoryErrors.selectedItem}
                helperText={addCategoryErrors.selectedItem ? "Mandatory Field" : ""}
                // displayEmpty
                margin="normal"
              >
                <MenuItem value="">Select item</MenuItem>
                <MenuItem value="Tenaga Kerja">Tenaga Kerja</MenuItem>
                <MenuItem value="Peralatan">Peralatan</MenuItem>
                <MenuItem value="Material">Material</MenuItem>
              </TextField>
            </Box>
          </Box>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          <Button variant="outlined" color="error" sx={{ width: 120 }} onClick={() => setOpenAddCategoryDialog(false)}>CANCEL</Button>
          <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitAddCategory}>SAVE</Button>
        </DialogActions>
      </Dialog>


      {/* POPUP Edit Item Category */}
      <Dialog open={openEditCategoryDialog} onClose={handleCancelEditCategory} fullWidth maxWidth="md"
        sx={{ backdropFilter: "blur(5px)" }}>
        <DialogTitle>
          <Box sx={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <Typography variant="h6" fontWeight="bold">Edit Item Category</Typography>
            <IconButton onClick={() => setOpenEditCategoryDialog(false)} color="error"><Close /></IconButton>
          </Box>
        </DialogTitle>

        <DialogContent>
          <Box sx={{ display: "flex", gap: 2 }}>
            {/* File Upload Section */}
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                border: "2px dashed #aaa",
                padding: 4,
                borderRadius: "12px",
                backgroundColor: "#fafafa",
                textAlign: "center",
                cursor: "pointer",
                position: "relative"
              }}
              disabled={!isEditingCategory}
              onDragOver={(e) => e.preventDefault()}
              onDrop={(e) => {
                if (isEditingCategory) {
                  e.preventDefault();
                  const file = e.dataTransfer.files[0];
                  handleEditCategoryFileUpload(file);
                }
              }}
              onClick={() => {
                if (isEditingCategory) {
                  editFileInputRef.current?.click()
                }
              }}
            >
              {editCategoryData.file ? (
                // Jika user baru upload gambar
                <img
                  src={URL.createObjectURL(editCategoryData.file)}
                  alt="Preview"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    objectFit: "contain",
                    maxHeight: 180,
                  }}
                />
              ) : editCategoryData.previewUrl ? (
                // Jika sudah ada foto dari server
                <img
                  src={editCategoryData.previewUrl}
                  alt="Existing"
                  style={{
                    width: "100%",
                    height: "auto",
                    borderRadius: "8px",
                    objectFit: "contain",
                    maxHeight: 180,
                  }}
                />
              ) : (
                // Jika tidak ada gambar sama sekali
                <>
                  <PhotoCamera fontSize="large" />
                  <Typography variant="body2" color="textSecondary" mt={1}>
                    Drag & drop or click to upload image
                  </Typography>
                </>
              )}

              <input
                hidden
                accept="image/png, image/jpeg, image/jpg"
                type="file"
                ref={editFileInputRef}
                onChange={(e) => handleEditCategoryFileUpload(e.target.files[0])}
              />
              <Typography variant="caption" mt={1}>
                Max size: 5MB (.png, .jpg, .jpeg)
              </Typography>
            </Box>

            <Box sx={{ flex: 2 }}>
              <TextField fullWidth label="Item Group Name" name="itemGroupName"
                margin="normal" value={editCategoryData.itemGroupName}
                onChange={handleEditCategoryInputChange} error={editCategoryErrors.itemGroupName}
                helperText={editCategoryErrors.itemGroupName ? "Mandatory Field" : ""}
                disabled={!isEditingCategory}
              />

              <TextField fullWidth label="Item Description" name="itemDescription"
                multiline rows={4} margin="normal" value={editCategoryData.itemDescription}
                onChange={handleEditCategoryInputChange} error={editCategoryErrors.itemDescription}
                helperText={editCategoryErrors.itemDescription ? "Mandatory Field" : ""}
                disabled={!isEditingCategory}
              />

              <Select fullWidth name="selectedItem"
                placeholder="Category"
                label="Category" displayEmpty margin="normal" value={editCategoryData.selectedItem}
                onChange={handleEditCategoryInputChange} error={editCategoryErrors.selectedItem}
                disabled={!isEditingCategory}
              >
                <MenuItem value="">Select item</MenuItem>
                <MenuItem value="Tenaga Kerja">Tenaga Kerja</MenuItem>
                <MenuItem value="Peralatan">Peralatan</MenuItem>
                <MenuItem value="Material">Material</MenuItem>
              </Select>
              {editCategoryErrors.selectedItem && (
                <Typography color="error">Mandatory Field</Typography>
              )}
            </Box>
          </Box>
        </DialogContent>

        {/* Dialog Actions */}
        <DialogActions sx={{ justifyContent: "space-between", padding: 2 }}>
          {!isEditingCategory ? (
            // Tombol Edit Muncul di Awal
            <Button onClick={() => setIsEditingCategory(true)} variant="contained" color="primary" sx={{ width: 120 }}>
              EDIT
            </Button>
          ) : (
            // Tombol Save & Cancel Muncul Saat Edit
            <>
              <Button onClick={() => setIsEditingCategory(false)} variant="outlined" color="error" sx={{ width: 120 }}>
                CANCEL
              </Button>
              <Button variant="contained" color="success" sx={{ width: 120 }} onClick={handleSubmitEditCategory}>
                SAVE
              </Button>
            </>
          )}
        </DialogActions>
      </Dialog>

      {/* ======================= Filter Dialog ============================= */}
      <Dialog open={openFilterDialog} onClose={() => setOpenFilterDialog(false)}>
        <DialogTitle>Advanced Search</DialogTitle>
        <DialogContent>
          {filters.map((filter, index) => {
            const usedFields = filters.map((f, i) => i !== index && f.field).filter(Boolean);
            const availableOptions = availableFilters.filter((opt) => !usedFields.includes(opt.value));

            return (
              <Box key={index} display="flex" alignItems="center" gap={1} mb={2}>
                <TextField
                  select
                  value={filter.field}
                  onChange={(e) => handleFilterChange(index, "field", e.target.value)}
                  variant="outlined"
                  size="small"
                  sx={{ mt: 1, minWidth: 160 }}
                >
                  {availableOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))}
                </TextField>

                <TextField
                  label="Value"
                  variant="outlined"
                  size="small"
                  value={filter.value}
                  onChange={(e) => handleFilterChange(index, "value", e.target.value)}
                  sx={{ mt: 1 }}
                />

                {index > 0 && (
                  <IconButton onClick={() => handleRemoveFilter(index)}>
                    <Remove />
                  </IconButton>
                )}
              </Box>
            );
          })}

          {filters.length < availableFilters.length && (
            <Button startIcon={<Add />} onClick={handleAddFilter}>
              Add Filter
            </Button>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleResetFilters}>Reset Filter</Button>
          <Button onClick={handleCloseFilter}>Cancel</Button>
          <Button variant="contained" onClick={handleApplyFilters} disabled={isLoading}>
            {isLoading ? "Loading..." : "Apply"}
          </Button>
        </DialogActions>
      </Dialog>

    </Box>
  );
};

export default Item;
